import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageStorageService {
  constructor() {}

  getLanguage(): string | null {
    return localStorage.getItem('userLanguage');
  }

  setLanguage(language: string): void {
    localStorage.setItem('userLanguage', language);
  }

  removeLanguage():void {
    localStorage.removeItem('userLanguage');
  }
}